<template>
  <div
    v-if="pricesAlwaysWithTax !== '1'"
    class="vat-toggle"
  >
    <label class="vat-toggle__label">
      <input
        v-model="vat"
        type="checkbox"
        value="true"
        class="checkbox-input vat-toggle__checkbox-input"
        :aria-disabled="$store.getters.isOffer"
        :disabled="$store.getters.isOffer"
      >
      <span class="checkbox-label vat-toggle__checkbox-label">{{
        $modeoL10n.show_prices_including_tax
      }}</span>
    </label>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
    props: {
        woocommerceSettings: {
            type: Object,
            default: function () {
                return {};
            },
        },
        orderType: {
            type: String,
            default: 'order',
        },
        pricesAlwaysWithTax: {
            type: String,
            default: '',
        },
    },
    computed: {
        vat: {
            get() {
                return this.$store.getters.showPricesWithVat;
            },
            set(value) {
                this.$store.commit('setShowPricesWithVat', value);
            },
        },
    },
    created: function () {
        this.$store.commit('setOrderType', this.orderType);
        this.$store.commit(
            'setProductIncludesTaxes',
            this.woocommerceSettings.prices_include_tax_in_shop
        );
        this.$store.commit(
            'setCartIncludesTaxes',
            this.woocommerceSettings.prices_include_tax_in_cart
        );
        this.$store.commit('setPricesIncludeTaxes', this.woocommerceSettings.prices_include_taxes);
    },
    mounted: function () {
        if (this.pricesAlwaysWithTax === '1') {
            this.$store.commit('setShowPricesWithVat', true);
            return;
        }

        if (this.$store.getters.isOffer) {
            this.$store.commit('setShowPricesWithVat', false);
            return;
        }

        if (typeof sessionStorage.showPricesWithVat !== 'undefined') {
            const payload = sessionStorage.showPricesWithVat === 'false';
            this.$store.commit('setShowPricesWithVat', payload);
        } else {
            const payload = (sessionStorage.showPricesWithVat === 'false');
            this.$store.commit( 'setShowPricesWithVat', payload );

            const confirmation = {
                message: this.$modeoL10n.prices_including_tax_confirmation,
                notificationType: 'info-message',
                autoHide: true,
                transition: 'none',
            };

            EventBus.$emit('notify', {
                message: this.$modeoL10n.show_prices_including_tax_nofication,
                notificationType: 'callback-message',
                autoHide: false,
                callToAction: this.$modeoL10n.yes,
                transition: 'none',
                callback: function () {
                    this.$store.commit('setShowPricesWithVat', false);
                    // without setTimeout the close call from the above notification closes this too.
                    setTimeout(function () {
                        EventBus.$emit('notify', confirmation);
                    }, 100);
                },
            });
        }
    },
};
</script>
